import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import ui from 'raypro_ui/src/store/modules/ui'
import user from 'raypro_ui/src/store/modules/user'
import auth from 'raypro_ui/src/store/modules/auth'
import onboarding from 'raypro_ui/src/store/modules/onboarding'
import website from 'raypro_ui/src/store/modules/website'
import httpErrors from 'raypro_ui/src/store/modules/httpRequests'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  modules: {
    ui,
    user,
    auth,
    httpErrors,
    onboarding,
    website
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js